import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LinkWidget } from '../../../core/models';
import { LinkItemWidgetComponent } from '../link-item-widget/link-item-widget.component';
import { Store } from '@ngrx/store';
import { generalFeature } from '@src/state/general';
import { userFeature } from '@src/state';
import { AppRouting } from '@core/enums';
import { isWidgetVisible } from '@core/helpers';

@Component({
  selector: 'sc-link-widget',
  imports: [LinkItemWidgetComponent],
  templateUrl: './links-list-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkWidgetComponent {
  public isDataOnly = this.store.selectSignal(generalFeature.selectIsDataOnly);
  public isB2B = this.store.selectSignal(userFeature.selectIsB2B);
  public activeProduct = this.store.selectSignal(userFeature.selectActiveProduct);

  public data = input<LinkWidget>(null);

  public filteredLinks = computed(() => {
    const isB2B = this.isB2B();
    const activeProduct = this.activeProduct();
    let links = this.data()?.linkList ?? [];

    if (this.isDataOnly()) {
      links = links.filter((link) => link.url && !link.url.includes(AppRouting.NetworkSettings));
    }

    return links.filter((link) => isWidgetVisible(link, activeProduct, isB2B));
  });

  constructor(private readonly store: Store) { }
}
